import { formatDuration } from '@/core/time';
import dayjs from 'dayjs';
import { FunctionComponent, useEffect, useState } from 'react';
import { Duration } from './Duration';

export const Countdown: FunctionComponent<{ estimatedCompletion: Date; startedAt?: Date | null }> = ({
  estimatedCompletion,
  startedAt,
}) => {
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(dayjs());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const remainingSeconds = Math.max(0, Math.ceil(dayjs(estimatedCompletion).diff(now, 'second')));

  if (remainingSeconds === 0 && startedAt) {
    return <Duration startedAt={startedAt} completedAt={null} />;
  }

  return (
    <span className='text-xs font-mono font-medium'>
      {remainingSeconds > 0 ? `~${formatDuration(remainingSeconds)}` : null}
    </span>
  );
};
